import { Route, Redirect } from 'react-router-dom'

//Redux
import { connect, selectors } from '../../stores'
import NotFound, { redirectedFlag } from '../routes/NotFound'

const handleRedirect = (redirectPath, match) => {
  let resolvedRedirectPath
  if (typeof redirectPath === 'function') {
    resolvedRedirectPath = redirectPath(match)
  } else {
    resolvedRedirectPath = redirectPath
  }
  if (resolvedRedirectPath.startsWith('/#/')) {
    window.location.replace(resolvedRedirectPath)
    return null
  } else {
    return <Redirect to={resolvedRedirectPath} />
  }
}

export const CommonRoute = ({
  canAccess,
  component: Component,
  render,
  isAuthenticated,
  redirectPath,
  requiresAuthentication,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        let result
        let search = new URLSearchParams(props.location.search)
        if (search.has(redirectedFlag)) {
          search.delete(redirectedFlag)
          let newLocation = { ...props.location, search: search.toString() }
          result = <Redirect to={newLocation} />
        } else if (
          (requiresAuthentication === true && isAuthenticated === true) ||
          requiresAuthentication === false
        ) {
          if (canAccess === true) {
            if (render) {
              result = render(props)
            } else {
              result = <Component {...props} />
            }
          } else if (redirectPath) {
            result = handleRedirect(redirectPath, props.match)
          } else {
            result = <NotFound location={props.location} />
          }
        } else {
          result = (
            <Redirect
              to={`/login?redirect_url=${encodeURIComponent(
                window.location.toString(),
              )}`}
            />
          )
        }
        return result
      }}
    />
  )
}

CommonRoute.defaultProps = {
  canAccess: true,
  requiresAuthentication: false,
}

export default connect((state) => ({
  ...selectors.auth.selectIsAuthenticated(state),
}))(CommonRoute)
